import { useLayoutEffect, useRef, useState } from 'react';
import { achievements } from '../data/achievements';

export const useAchievementScroll = (count: number) => {
  const listRef = useRef<HTMLUListElement>(null);
  const thumbRef = useRef<HTMLDivElement>(null);
  const [scrollPos, setScrollPos] = useState<'top' | 'middle' | 'bottom'>(
    'top'
  );
  const nextIndex = achievements.findIndex(a => count < a.count);

  const updateScroll = () => {
    const el = listRef.current;
    const thumb = thumbRef.current;
    if (!el || !thumb) return;
    const { scrollTop, scrollHeight, clientHeight } = el;
    if (scrollTop <= 1) setScrollPos('top');
    else if (scrollTop + clientHeight >= scrollHeight - 1)
      setScrollPos('bottom');
    else setScrollPos('middle');
    const ratio = clientHeight / scrollHeight;
    const thumbHeight = Math.max(ratio * clientHeight, 28);
    const thumbTop =
      scrollHeight > clientHeight
        ? (scrollTop / (scrollHeight - clientHeight)) *
          (clientHeight - thumbHeight)
        : 0;
    thumb.style.height = `${thumbHeight}px`;
    thumb.style.top = `${thumbTop}px`;
  };

  useLayoutEffect(() => {
    const el = listRef.current;
    if (el && nextIndex > 0) {
      const target = el.children[nextIndex] as HTMLElement;
      if (target) {
        el.scrollTop =
          target.offsetTop - el.clientHeight / 2 + target.offsetHeight / 2;
      }
    }
    updateScroll();
  }, []);

  return { listRef, thumbRef, scrollPos, updateScroll };
};
